<template>
  <div class="v-update-dealer-payment-modal">
    <div class="modal-backdrop">
      <div class="modal">
        <header class="modal-header">
          <slot name="header">
            <h5>Редактировать платеж дилеру</h5>
            <button type="button" class="btn-close" @click="close">x</button>
          </slot>
        </header>
        <section class="modal-body">
          <slot name="body">
            <form class="form" @submit.prevent="submitDealerPayment">
              <div class="row mx-3">
                <div class="col-12 pb-3">
                  <textarea name="comment" rows="2" class="p-3"
                            v-model="payment_inputs.description"
                            placeholder='Комментарий'>
                  </textarea>
                </div>
                <div class="col">
                   <button class="btn btn-primary" @click="cancelDealerPayment">
                     Отклонить платеж
                   </button>
                </div>
                <div class="col">
                  <button type="submit" class="btn btn-primary">
                    Подтвердить платеж
                   </button>
                </div>
              </div>
            </form>
          </slot>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'v-update-dealer-payment-modal',
  props: ['payment'],
  data() {
    return {
      payment_inputs: { description: '', is_paid: true },
    };
  },
  methods: {
    ...mapActions('payment', ['updateDealerPayment']),
    close() {
      this.$emit('close');
    },
    cancelDealerPayment() {
      this.payment_inputs.is_paid = false;
      this.submitDealerPayment();
    },
    submitDealerPayment() {
      const updateData = { id: this.payment, data: this.payment_inputs };
      this.updateDealerPayment(updateData)
        .then(() => { this.close(); });
    },
  },
};
</script>
